import React, { Component, PropTypes } from 'react'

import Input from './input'

class InputContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      value: '',
      error: props.error,
    }
    this.handleChange = this.handleChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ error: nextProps.error })
  }

  handleChange(e) {
    const { value } = e.target
    const { name, onChange, error } = this.props

    this.setState({ value, error: value ? false : error })

    if (onChange) {
      onChange(name, value)
    }
  }

  render() {
    return (
      <Input
        {...this.props}
        {...this.state}
        onChange={this.handleChange}
      />
    )
  }
}

InputContainer.propTypes = {
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  optional: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
}

export default InputContainer



/** WEBPACK FOOTER **
 ** ./src/components/input/input-container.js
 **/